import React from 'react';
import { motion } from 'framer-motion';
import { coverageHubs } from '../data/site';
const COLS = 23;
const ROWS = 12;

// Abstract dot-matrix silhouette of the continental United States.
const dotRows: number[][][] = [[[2, 21]], [[1, 22]], [[1, 22]], [[1, 22]], [[2, 22]], [[2, 22]], [[3, 21]], [[4, 21]], [[5, 20]], [[7, 19]], [[9, 18], [20, 20]], [[11, 17], [20, 21]], [[12, 16], [21, 21]]];
const hq = coverageHubs.find(hub => hub.hq) ?? coverageHubs[0];
const spokes = coverageHubs.filter(hub => !hub.hq);
export function CoverageMap() {
  const dots: {
    x: number;
    y: number;
  }[] = [];
  dotRows.forEach((segments, row) => {
    segments.forEach(([start, end]) => {
      for (let col = start; col <= end; col += 1) {
        dots.push({
          x: col / COLS * 100,
          y: row / ROWS * 100
        });
      }
    });
  });
  return <div className="relative w-full" role="img" aria-label="Map of the continental United States showing Hold Fast Hauling's 48-state coverage from Davenport, Florida" data-id="element-145" data-mp="3q2fucnmrx0mw">
      <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="h-[19rem] w-full sm:h-[24rem] lg:h-[30rem]" data-id="element-146" data-mp="qg2lxp57ytg7">
        {dots.map(dot => <circle key={`${dot.x}-${dot.y}`} cx={dot.x} cy={dot.y} r="0.7" fill="#ffffff" opacity="0.22" data-id="element-147" data-mp="hdt8orikglz4" />)}

        {spokes.map((hub, i) => <motion.line key={hub.name} x1={hq.x} y1={hq.y} x2={hub.x} y2={hub.y} stroke="#66b6e0" strokeWidth="0.35" strokeLinecap="round" initial={{
        pathLength: 0,
        opacity: 0
      }} whileInView={{
        pathLength: 1,
        opacity: 0.75
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.9,
        delay: 0.15 + i * 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-148" data-mp="mdz84tv2vcrr" data-mpi={i} />)}

        {coverageHubs.map((hub, i) => <motion.g key={hub.name} initial={{
        opacity: 0,
        scale: 0.6
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.3,
        delay: 0.2 + i * 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} style={{
        transformOrigin: `${hub.x}% ${hub.y}%`
      }} data-id="element-149" data-mp="1xs31pyxr6ywa" data-mpi={i}>
            {hub.hq && <circle cx={hub.x} cy={hub.y} r="2.4" fill="#66b6e0" opacity="0.22" data-id="element-150" data-mp="1sqsl0aeo9cpv" />}
            <circle cx={hub.x} cy={hub.y} r={hub.hq ? 1.2 : 0.9} fill={hub.hq ? '#ffffff' : '#66b6e0'} data-id="element-151" data-mp="1oo5t69i03rso" />
          </motion.g>)}
      </svg>

      <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2" data-id="element-152" data-mp="1jw4kexk1kj7e">
        {coverageHubs.map(hub => <li key={hub.name} className="flex items-center gap-2 text-xs text-white/55" data-id="element-153" data-mp="1ez49a88c4q9f">
            <span className={`h-1.5 w-1.5 rounded-full ${hub.hq ? 'bg-white' : 'bg-ice-400'}`} aria-hidden="true" data-id="element-154" data-mp="1a0udbvesdlmr" />
            {hub.name}
            {hub.hq && <span className="text-white/35" data-id="element-155" data-mp="10zwahgg33k5r">— HQ</span>}
          </li>)}
      </ul>
    </div>;
}